import request from "@/service";

/* 查询所有公告列表 */
// export function getNewsParamList(params) {
//   return request({
//     url: `/resource/pub/news/page?page=${params.page}&limit=${
//       params.limit
//     }&newsTitle=${
//       params.newsTitle !== undefined ? params.newsTitle : ""
//     }&onlineStatus=${
//       params.onlineStatus !== undefined ? params.onlineStatus : ""
//     }&setTop=${params.setTop !== undefined ? params.setTop : ""}`,
//     method: "get"
//   });
// }
// 获取新闻列表
export function getNewsParamList(params) {
  return request({
    url: `/resource/pub/news/page`,
    method: "get",
    params
  });
}

/* 新增公告 */
export function newsSave(data) {
  return request({
    url: `/resource/pub/news/save`,
    method: "post",
    data
  });
}

/* 修改公告 */
export function newsUpdate(data) {
  return request({
    url: `/resource/pub/news/update`,
    method: "put",
    data
  });
}

/* 删除公告 */
export function newsDel(data) {
  return request({
    url: `/resource/pub/news/delete`,
    method: "delete",
    data
  });
}

/* 上架下架 */
export function newsOnline(data) {
  return request({
    url: `/resource/pub/news/online`,
    method: "put",
    data
  });
}

/* 是否置顶 */
export function newsTop(data) {
  return request({
    url: `/resource/pub/news/top`,
    method: "put",
    data
  });
}

/* 获取新闻列表 */
export function getNoRNews() {
  return request({
    url: `/resource/pub/news/getNoRNews`,
    method: "get"
  });
}

// 获取新闻列表
export function getNewsByName(params) {
  return request({
    url: `/resource/pub/news/namePage`,
    method: "get",
    params
  });
}

//新闻统计-概况-shijunjian
export function newsBasic(params) {
  return request({
    url: `/resource/pub/news/statistic/basic`,
    method: "get",
    params
  });
}

// 新闻统计-学习明细-shijunjian
export function newsLearn(data) {
  return request({
    url: `/resource/pub/news/statistic/learn`,
    method: "post",
    data
  });
}

/* 导出新闻统计信息-shijunjian */
export function exportNewsStatisticInfo(data) {
  return request({
    url: `/resource/pub/news/export`,
    method: "post",
    responseType: "blob",
    headers: {
      Accept: "application/json, text/plain, */*, application/octet-stream",
      "Content-Type": "application/json;charset=UTF-8"
    },
    data
  });
}